import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BaseImageUrl } from '../../../utils/BaseUrl';
import RenderReviews from './RenderReviews';
import SocialProfile from './SocialProfile';
import CollateralImageListing from './CollateralImageListing';
import Popup from './Popup';
import educationImg from '../../../Assets/images/education.png';
import companyImg from '../../../Assets/images/company.png';
import ContentLoader, { Facebook } from 'react-content-loader'
import FixFooter from '../Home/MobileDashboard/FixFooter';
import RenderProjects from './RenderProjects';
// import TimeRetainer from './TimeRetainer';
import { getAPI } from '../../../utils/API';
// import { BiRupee } from 'react-icons/bi';
import { capitalizeWordFirstLetter, separateNumber } from '../../../utils/Helperfunctions';
import { Helmet } from 'react-helmet';

const CLIENT_IMAGE_BASE_URL = BaseImageUrl;
const MyInstagramLoader = () => <Facebook />
const MyListLoader = (props) => (
  <ContentLoader
    // speed={2}
    // width={'100%'}
    // height={150}
    // viewBox="0 0 700 150"
    // backgroundColor="#f3f3f3"
    // foregroundColor="#ecebeb"
    // {...props}
    style={{ textAlign: 'center', width: '100%' }}
  >
    <rect x="10%" y="15" rx="5" ry="5" width="80%" height="20" />
    <rect x="10%" y="45" rx="5" ry="5" width="80%" height="20" />
    <rect x="10%" y="75" rx="5" ry="5" width="80%" height="20" />
    <rect x="10%" y="105" rx="5" ry="5" width="80%" height="20" />

    {/* <rect y="10" rx="" ry="" width="100%" height="10" />
      <rect y="25" rx="" ry="" width="100%" height="10" />
      <rect y="40" rx="" ry="" width="100%" height="10" />
      <rect y="55" rx="" ry="" width="100%" height="10" /> */}
    {/* <rect  y="15" rx="5" ry="5" width="80%" height="20" /> 
      <rect  y="30" rx="5" ry="5" width="80%" height="20" /> 
      <rect  y="45" rx="5" ry="5" width="80%" height="20" /> 
      <rect  y="60" rx="5" ry="5" width="80%" height="20" /> */}
  </ContentLoader>
)
class ViewCreatorProfile extends Component {
  state = {
    startsFrom: 0,
    activeTab: 'works',
    showCollateralList: false,
    isShowAllProjects: true,
    selectedCollateral: '',
    projectDropdown:"All",
    time_base_duration:'',
    time_base_amount:0,
    loadTimeBase:false,
    freelance_hour:"",
    updatedIndustry:[]
  }

  editProject = (projectId) => {
    const { history } = this.props;
    this.props.closePopup()
    this.props.editUserProject(projectId, history);
  };

  requestReview = (projectId) => {
    this.props.onFieldChange({
      name: 'REVIEW_PROJECT_ID',
      value: projectId,
    });
  };

  handleDeleteProject = (projectId, isFromAllProjects) => {
    const isConfirm = window.confirm('Do you want to delete the project?')
    if (!isConfirm) return
    this.props.DeleteCreatorProject(projectId, isFromAllProjects)
  }

  hireCreator = async () => {
    const { history, FirstName, LastName, userProfile ,CreatorId} = this.props;
    // const previousUrl = window.location.href;
    const creatorName = FirstName + " " + LastName;
    const clientEmail = userProfile ? userProfile.email : '';
    const clientName = userProfile ? userProfile.first_name + " " + userProfile.last_name : '';
    const clientPhone = userProfile ? userProfile.phone_no : '';
    await this.props.hireAgain(CreatorId)
    // history.push(`/hire?rehire=true&firstname=${FirstName}&lastname=${LastName}&previousUrl=${previousUrl}`)
    history.push(`/hire?rehire=true&firstname=${FirstName}&lastname=${LastName}`,{ prevPath : window.location.pathname });
  }


  handleCollateralScroll = (type) => {
    const { Collateral } = this.props;
    const { startsFrom } = this.state;

    if (type === 'add') {
      if (startsFrom === Collateral.length - 2 || Collateral.length < 4) {
        return;
      }
      this.setState({ startsFrom: startsFrom + 1 })
    } else {
      if (startsFrom === 0) {
        return;
      }
      this.setState({ startsFrom: startsFrom - 1 })
    }

  }


  handleTabs = (tabName) => {

    this.setState({ activeTab: tabName,showCollateralList:false })
  }

  handleCollateralChange = () => {
    //console.log('handle collateral change')
  }
  handleCreatorDisabled = (currentRole, status) => {
    if (currentRole === 2 && status === 3) {
      return true
    } else {
      return false
    }
  }
   capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }




  componentWillReceiveProps(){
    this.setState({updatedIndustry:this.props.UserIndustries})
    
    if(!this.props.publicView) {
      getAPI('/users/user-profile').then((res) => {
        if (res.data.status === "1") {
            // console.log(res.data.data)
            const {time_base_duration,time_base_amount,freelance_hour} =res.data.data
            this.setState({time_base_duration,time_base_amount,loadTimeBase:true,freelance_hour:freelance_hour})
            
        //  setLoad(true);
        }
          }).catch((error) => {
          // alert('Something went wrong, Please try again later.');
        
          console.log("user-company api error------->", error)
        })
    }
    
  
  }


  render() {
    let {
      Specilizations,
      Tools,
      Collateral,
      Experience,
      Education,
      Languages,
      Award,
      Projects,
      publicView,
      Avatar,
      creatorClients,
      AllProjects,
      isFetching,
      isAvailable,
      userName,
      publicCurrentRoleSet,
      publicStatus,
      AllReviews,
      UserIndustries
    } = this.props;
  
    // console.log("AllProjects = ",AllProjects);
    const { startsFrom, activeTab, showCollateralList, selectedCollateral, isShowAllProjects,freelance_hour , updatedIndustry} = this.state;
    const hasAnyReviews = AllReviews?.length;
    const reviewCount = AllReviews?.length;
    // console.log(reviewCount, TransactionReviews, AllReviews)
    const hasClients = creatorClients.find(client => client.client_name)
    const isDashboardDisabled = this.handleCreatorDisabled(publicCurrentRoleSet, publicStatus);
    
    const name = `${this.props.FirstName} ${this.props.LastName}`;
    const titleName = capitalizeWordFirstLetter(name)
    return (
      <React.Fragment>
        <Helmet>
          <title >{titleName ? `${titleName} || IndieFolio` : ''}</title>
        </Helmet>
        <section>
          <div className="container-fluid p-4 mob-p-0 ipad-normal-p-0 max-w-1440">
            <div className="row m-0">
              <div className="col-sm-9 col-md-9 col-lg-9 profile-inner mob-p-0 ipad-normal-col-100 ipad-normal-p-0">
                <div className="card-wrapper mob-text-center mob-mb-10 ipad-mb-15">
                  <div className="card mob-border-radius-0">
                    <div className="card-body">
                      <div className="row m-0 pX_pY_30 mob-pb-10 position-relative">
                        <div className="edit_icon hidden">
                          <i className="fas fa-ellipsis-h"></i>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          {(!isFetching) ?
                            <div className="d-flex mob-d-block">
                              <div className="profile-user">
                                <div className="basic_profile mx-auto">
                                  {!Avatar || Avatar === '' ? (
                                    <img
                                      src={require('../../../Assets/images/user-default.png')}
                                      alt="profile"
                                      title=""
                                    />
                                  ) : (
                                    <img
                                      src={BaseImageUrl + this.props.Avatar}
                                      alt="profile"
                                      title=""
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="w-100">
                                <div className="d-block pl-4 mob-p-0">
                                  <h2 className="profile_title pt-2 text-capitalize">
                                    {this.props.FirstName} {this.props.LastName}
                                    {publicView === true ? (
                                      <></>
                                    ) : (
                                      <div
                                        onClick={(e) =>
                                          this.props.OpenPopup('BasicDetails')
                                        }

                                        className="font-12 font-weight-600 cursor-pointer text-primary float-right mob_display_none_off"
                                      // data-toggle="modal"
                                      // data-target="#EditProfileModal"
                                      >
                                        <i className="fas fa-pencil-alt"></i> Edit
                                      </div>
                                    )}
                                  </h2>
                                  <span className="profile-subTitle text-capitalize mob-mb-20">
                                    {this.props.PrimaryFieldWork}{' '}
                                    <span className="dot pl-3">
                                      {this.props.Location}, {this.props.Country}
                                    </span>
                                  </span>                                                       
                                  {publicView === true && isAvailable ? (
                                      <div className="col-sm-12 p-0 mb-0 mobile-ipad-show"> 
                                        {isDashboardDisabled ? <button
                                          type="button"
                                          className="main-btn w-100 mb-3 text-capitalize"
                                          disabled={true}
                                          style={{opacity:0.5}}
                                        >
                                          Unavailable
                                        </button> : <button
                                          type="button"
                                          className="main-btn w-100 mb-3 text-capitalize"
                                          disabled={!this.props.Collateral.length}
                                          onClick={this.hireCreator}
                                        >
                                          Hire {this.props.FirstName}
                                        </button>}
                                      </div>
                                    ) : (
                                      <></>
                                  )}
                                  <p className="w-75 pt-2 font-weight-500 mob-w-100 ipad-w-100 mobile-ipad-none">
                                    {this.props.About}
                                    {publicView === true ? (
                                      <></>
                                    ) : (
                                      <a href="/"
                                        onClick={(e) =>{e.preventDefault();
                                          this.props.OpenPopup('BasicDetails');
                                        }}

                                        className="font-12 font-weight-600 text-primary text-center pt-3 mobile-ipad-show cursor-pointer" 
                                      >
                                        <i className="fas fa-pencil-alt"></i> Edit
                                      </a>
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div> : <MyInstagramLoader />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-wrapper mob-text-center mobile-ipad-show mob-mb-10 hidden">
                  <div className="card mt-2 mob-border-radius-0">
                    <div className="card-body">
                      <div className="rating py-3 w-100">
                        <p className="mob-font-20 font-weight-800 text-dark-black mob-d-block">
                          <i className="fas fa-star text-success"></i>{' '}
                          {this.props.Rating}{' '}
                          <span className="d-block mob-font-13 text-primary">
                            {this.props.Reviews} User reviews
                          </span>
                        </p>
                        <ul className="dflex pb-2 overflow-hidden">
                          <li className="mob-p-0 mob-w-75 ipad-w-75">
                            {this.props.ProjectCompleted}{' '}
                            <span className="d-block w-75 m-auto font-weight-500">
                              Projects Completed
                            </span>
                          </li>
                          <li className="mob-p-0 mob-w-75 ipad-w-75">
                            {this.props.AvgResponseTime} hrs{' '}
                            <span className="d-block w-75 m-auto font-weight-500">
                              Avg. response time
                            </span>
                          </li>
                          <li className="mob-p-0 mob-w-75 ipad-w-75">
                            {this.props.RepeatHire}{' '}
                            <span className="d-block w-50 m-auto font-weight-500">
                              Repeat hires
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {Collateral && Collateral.length ?
                  <div className="card-wrapper mob-mb-10">
                    <div className="main-content mob-bg-white mob-p-15 ipad-p-15 border-radius-8 position-relative mob-border-radius-0">
                      <div className="mobile-ipad-none">
                        {Collateral && Collateral.length > 6 ? <div className="prev_tabs"><i className="fas fa-chevron-left" onClick={this.handleCollateralScroll.bind(this, 'subtract')}></i></div> : null}

                        <ul
                          className="nav nav-tabs bor-bottom project_nav_tabs"
                          id="myTab"
                          role="tablist"
                        >
                          {(publicView && AllProjects.length) || !publicView ?
                            startsFrom === 0 ? <li className={`nav-item`} key={'allProjects'}>
                              <a
                                className={`nav-link text-capitalize ${isShowAllProjects ? 'active' : ''}`}
                                id={'allProjects'}
                                data-toggle="tab"
                                href={`#tab_${'allProjects'}`}
                                role="tab"
                                aria-controls="home"
                                aria-selected="true"
                                onClick={() => {
                                  this.props.ResetCollateralBasedProjects();
                                  this.setState({ isShowAllProjects: true, selectedCollateral: '' })
                                  this.props.loadAllProjects()
                                }}
                              >
                                All
                          </a>
                            </li> : null
                            : null}
                          {Collateral && Collateral.length > 0 ? (
                            Collateral.map((cl, index) => {
                              if (index >= startsFrom) {
                                return <li className={`nav-item`} key={index}>
                                  <a href="/"
                                    className={`nav-link text-capitalize cursor-pointer ${cl.collateral_id === selectedCollateral ? 'active' : ''
                                      }`}
                                    // id={cl.collateral_id}
                                    // data-toggle="tab"
                                    // href={`#tab_${index}`}
                                    // role="tab"
                                    // aria-controls="home"
                                    // aria-selected="true"
                                    onClick={(e) => {e.preventDefault();
                                      this.props.LoadCollateralBasedProjects(cl.collateral_id);
                                      this.setState({ isShowAllProjects: false, selectedCollateral: cl.collateral_id });
                                    }}
                                  >
                                    {cl.collateral_name}
                                  </a>
                                </li>
                              } else return null
                            })
                          ) : (
                            null
                          )}
                        </ul>

                        {Collateral && Collateral.length > 6 && Collateral.filter(collateral => collateral.status === 1).length ? <div className="next_tabs"><i className="fas fa-chevron-right" onClick={this.handleCollateralScroll.bind(this, 'add')}></i></div> : null}

                      </div>

                      <div className="ipad-only-show message-folder">
                        <div className="wrapper-form p-1">
                          <div className="row m-0 align-items-center">
                            <div onClick={this.handleTabs.bind(this, 'works')} className="col-6 col-sm-6 p-0">
                              <a href="/" onClick={e=>e.preventDefault()} className={`tabs-folder py-8 font-weight-500 ${activeTab === 'works' ? 'active' : ''}`}>Works</a>
                            </div>
                            <div onClick={this.handleTabs.bind(this, 'about')} className="col-6 col-sm-6 p-0">
                              <a href="/" onClick={e=>e.preventDefault()} className={`tabs-folder py-8 font-weight-500 ${activeTab === 'about' ? 'active' : ''} `}>About</a>
                            </div>
                          </div>
                        </div>
                        {activeTab === 'works' && Collateral && Collateral.length ? <div className="row m-0">
                          <div className="filter-dropdown col-12 p-0 mt-4">
                            <div className="select">
                              <div className="select">

                                <div className={`select-styled ${false ? 'border-error' : ''}`} onClick={() => this.setState({ showCollateralList: !showCollateralList })}
                                // tabIndex="0" 
                                //onBlur={ this.handleShowGender } 
                                >
                                  {Collateral.filter(obj => obj.collateral_id === this.props.defaultCollateral)[0] ?
                                  Collateral.filter(obj => obj.collateral_id === this.props.defaultCollateral)[0].collateral_name : ''}
                                  {this.state.projectDropdown}
                                </div>
                                {/* {console.log(Collateral && Collateral.length > 0 ? Collateral.filter(obj => obj.collateral_id == this.props.defaultCollateral)[0] : 'random...')} */}
                                {
                                  showCollateralList &&
                                  <ul className="select-options hideList1" style={{ display: "block" }}>
                                    <li rel="Choose here" onClick={() => {
                                  this.props.ResetCollateralBasedProjects();
                                  this.setState({ isShowAllProjects: true, selectedCollateral: '' })
                                  this.props.loadAllProjects()
                                }}>All</li>
                                    {
                                      Collateral && Collateral.map((obj, index) => (
                                        <li key={index} rel={obj} onClick={(e) => {  this.props.LoadCollateralBasedProjects(obj.collateral_id);
                                          this.setState({ isShowAllProjects: false, selectedCollateral: obj.collateral_id, projectDropdown:obj.collateral_name });
                                            }}>{obj.collateral_name}</li>
                                      ))
                                    }
                                  </ul>
                                }
                              </div>
                            </div>
                            <i className="fas fa-chevron-down select-arrow without-label"></i>
                          </div>
                        </div> : null}
                      </div>
                      {isShowAllProjects && activeTab === 'works' ?
                        (publicView && AllProjects.length) || !publicView ?
                          <ol className={`content custom_form`}>
                            <RenderProjects
                              username={this.props.userName}
                              projects={AllProjects}
                              publicView={publicView}
                              isFromAllProjects={true}
                            />
                          </ol> : null
                        :
                        activeTab === 'works' && <ol className={`content custom_form`}>
                          <RenderProjects
                            projects={Projects}
                            publicView={publicView}
                            isFromAllProjects={false}
                          />
                        </ol>
                      } 
                    </div>
                  </div> : null}
                {hasAnyReviews && activeTab === 'works' ? (
                  <div className="card-wrapper mob-mb-90">
                    <div className="card mob-border-radius-0">
                      <div className="card-body">
                        <div className="profile-headline dflex py-3">
                          <h2 className="font-weight-600 py-2 mob-font-14">
                            Reviews {' '}
                            <span className="rectangle ml-1">
                              {reviewCount}
                            </span>
                          </h2>
                        </div>
                        <RenderReviews 
                          reviews={AllReviews}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className={`col-sm-3 col-md-3 col-lg-3 profile-inner mob-p-0 ipad-normal-col-100 ${activeTab === 'about' ? '' : 'ipad-only-hide'} `}> 
                {publicView === true ? (
                  <></>
                ) : (
                  <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`/creator/${this.props.userName}`}
                      className="text-white"
                      disabled={!this.props.ApprovedStatus}
                    >
                  <div className="card-wrapper mb-20 mob-mt-15 mob-mx-15 text-center main-btn">
                      View public profile
                  </div>
                    </a>
                )}
                <div className="card-wrapper mb-20 mob-mb-10 mobile-ipad-show">
                  <div className="card mob-border-radius-0">
                    <div className="card-body">
                      <div className="row m-0 px-4 pt-4 pb-3 ipadPro-p-15">
                        <div className="col-sm-12 dflex px-0">
                          <div>
                            <h2 className="text-capitalize text-light-color font-15 font-weight-600 mb-2">About</h2>
                          </div>
                          <div>
                            {publicView === true ? (
                              <></>
                            ) : (
                              <a href="/"
                                onClick={(e) =>{e.preventDefault();
                                  this.props.OpenPopup('BasicDetails');
                                }}

                                className="font-12 font-weight-600 text-primary text-center mobile-ipad-show cursor-pointer" 
                              >
                                <i className="fas fa-pencil-alt"></i> Edit
                              </a>
                            )}
                          </div> 
                        </div>
                        <div className="col-sm-12 font-weight-500 mob-w-100 ipad-w-100 text-left px-0">
                          {this.props.About} 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {publicView === true ? (
                  <></>
                ) : (
                  <div className="card-wrapper mb-20 mob-mb-10">
                    <div className="card mob-border-radius-0">
                      <div className="card-body">
                        {/* {(this.props.CurrentWorkStatus) ?  */}
                        {(!isFetching) ?
                          <div className="row m-0 px-4 pt-4 pb-3 ipadPro-p-15">
                            <div className="col-sm-12 dflex p-0">
                              <p className="sub-text font-12 font-weight-500 mb-1 d-inline">
                                Current Status
                            </p>
                              {publicView === true ? (
                                <></>
                              ) : (
                                <a href="/"

                                  onClick={(e) =>{e.preventDefault();
                                    this.props.OpenPopup('CurrentWorkStatus')
                                  }}
                                  className="font-12 font-weight-600 text-primary cursor-pointer"
                                // data-toggle="modal"
                                // data-target="#EditCurrentWorkStatus"
                                >
                                  <i className="fas fa-pencil-alt"></i> Edit
                                </a>
                              )}
                            </div>
                            <div className="col-sm-12 p-0">
                              <h2 className="text-light-color font-14 font-weight-600 text-underline mb-0 active">
                                {this.props.CurrentWorkStatus}
                              </h2>
                            </div>
                            
                            {publicView === true ? (
                              <></>
                            ) : (
                              <>
                                <div className="col-sm-12 dflex p-0 mt-3">
                                  <p className="sub-text font-12 font-weight-500 mb-1 d-inline">
                                    Availability
                                  </p>
                                  {publicView === true ? (
                                    <></>
                                  ) : (
                                    <a href="/"

                                      onClick={(e) =>{e.preventDefault();
                                        this.props.OpenPopup('Availability')
                                      }}
                                      className="font-12 font-weight-600 text-primary cursor-pointer"
                                    // data-toggle="modal"
                                    // data-target="#EditCurrentWorkStatus"
                                    >
                                      <i className="fas fa-pencil-alt"></i> Edit
                                    </a>
                                  )}
                                </div>
                              
                              
                                <div className="col-sm-12 p-0">
                                  <h2 className="text-light-color font-14 font-weight-600 text-underline mb-0 active">
                                    {freelance_hour?freelance_hour+' Hours/Week':" - "}
                                  </h2>
                                </div>
                              </>
                            )}
                            {publicView === true ? (
                              <></>
                            ) : (
                              <>
                                <div className="col-sm-12 dflex px-0 pt-4">
                                  <p className="sub-text font-12 font-weight-500 mb-1 d-inline">
                                    Social profiles
                                </p>
                                  <a href="/"

                                    onClick={(e) =>{e.preventDefault();
                                      this.props.OpenPopup('WebLinks')
                                    }}
                                    className="font-12 font-weight-600 text-primary cursor-pointer"
                                  // data-toggle="modal"
                                  // data-target="#EditWebLinkModal"
                                  >
                                    <i className="fas fa-pencil-alt"></i> Edit
                                </a>
                                </div>
                                <div className="col-sm-12 p-0">
                                  <p className="py-2 d-flex align-items-center flex-wrap social_images">
                                    <SocialProfile
                                      social={this.props.SocialProfiles}
                                    />
                                  </p>
                                  <button
                                    type="button"
                                    className="main-btn w-100 bg-light-gray font-12 py-1 font-weight-500"
                                  >
                                    <i className="fas fa-info-circle mr-1"></i>{' '}
                                  This information in only visible to you
                                </button>
                                </div>
                              </>
                            )}
                          </div> :
                          <MyListLoader />}
                      </div>
                    </div>
                  </div>
                )}

                  {publicView===true?<></>:
                   <div className={`card mb-3 ${this.state.loadTimeBase&&this.state.time_base_amount===0?'border-danger box-shadow-highlight text-left':''} `} >
                     <div className="card-body ">
                     {(!isFetching) ?
                          <div className="row m-0 px-4 pt-4 pb-3 ipadPro-p-15">
                            <div className="col-sm-12 dflex mb-2 p-0">
                              <p className=" text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0">
                                Time Based Pricing
                            </p>
                              {publicView === true ? (
                                <></>
                              ) : (
                                <a href="/"

                                  onClick={(e) =>{e.preventDefault();
                                    this.props.OpenPopup('TimeBasedPricing')
                                  }}
                                  className="font-12 font-weight-600 text-primary cursor-pointer"
                                // data-toggle="modal"
                                // data-target="#EditCurrentWorkStatus"
                                >
                                  <i className="fas fa-pencil-alt"></i> Edit
                                </a>
                              )}
                            </div>
                            <div className="col-sm-12 p-0">
                              <h2 className="text-sub-4 font-13 font-weight-600 text-underline mb-2 active">
                                Price: <span className='text-dark mx-1'><i className="fas fa-rupee-sign"></i> {this.state.time_base_amount===0?'unavailable':separateNumber(this.state.time_base_amount)}</span><span className='capitalize font-12'>{this.state.time_base_amount===0?'' :'per '}{this.state.time_base_duration}</span>
                              </h2>
                              {/* <h2 className="text-light-color font-14 font-weight-600 text-underline  mb-2 active">
                                Time Period : <span className='capitalize text-muted'>{this.state.time_base_duration}</span>
                              </h2> */}
                            </div>
                           
                          </div> :
                          <MyListLoader />}
                       {/* <TimeRetainer /> */}

                        
                      </div>
                   </div>
                  }


                <div className="card-wrapper custom_form mb-20 mob-m-0">
                  <div className="card mob-border-radius-0">
                    <div className="card-body">

                      {/* {(this.props.Collateral.length > 0) ? */}
                      {(!isFetching) ?
                        <>
                          <div className="row m-0 p-4 right_sidebar bor-bottom ipadPro-p-15"> 
                            {publicView === true && isAvailable ? (
                              <div className="col-sm-12 p-0 mb-0 mobile-ipad-none"> 
                                {isDashboardDisabled ? <button
                                  type="button"
                                  className="main-btn w-100 mb-4 text-capitalize"
                                  disabled={true}
                                  style={{opacity:0.5}}
                                >
                                  Unavailable
                                </button> : <button
                                  type="button"
                                  className="main-btn w-100 mb-4 text-capitalize"
                                  disabled={!this.props.Collateral.length}
                                  onClick={this.hireCreator}
                                >
                                  Hire {this.props.FirstName}
                                </button>}
                              </div>
                            ) : (
                              <></>
                            )} 
                            <div className="col-sm-12 dflex p-0 mb-4">
                              <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                                {publicView ? 'Collaterals offered' : 'Collaterals Offered & Pricing'}
                              </h2>
                              {publicView === true ? (
                                <></>
                              ) : (
                                <a
                                    href="/"
                                  onClick={(e) =>{e.preventDefault();
                                    this.props.OpenPopup('Collateral');
                                  }}
                                  className="font-12 font-weight-600 text-primary cursor-pointer"
                                // data-toggle="modal"
                                // data-target="#EditCollateralModal"
                                >
                                  <i className="fas fa-pencil-alt"></i> Edit
                                </a>
                              )}
                            </div>
                            <CollateralImageListing collateral={this.props.Collateral} />
                          </div>
                        </>
                        : <MyListLoader />}
                      {/* {(Specilizations && Specilizations.length > 0) ? */}
                      {(!isFetching) ?
                        // <div className="row m-0 p-4 bor-bottom ipadPro-p-15">
                        //   <div className="col-sm-12 dflex p-0">
                        //     <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                        //       Specializations
                        //   </h2>
                        //     {publicView === true ? (
                        //       <></>
                        //     ) : (
                        //       <a href="/"

                        //         onClick={(e) =>{e.preventDefault();
                        //           this.props.OpenPopup('Specialization');
                        //         }}
                        //         className="font-12 font-weight-600 text-primary cursor-pointer"
                        //         data-keyboard="true"
                        //       // data-toggle="modal"
                        //       // data-target="#EditSpecializationsModal"
                        //       >
                        //         <i className="fas fa-pencil-alt"></i> Edit
                        //       </a>
                        //     )}
                        //   </div>
                        //   <div className="col-sm-12 px-0 pt-3 d-flex align-items-center flex-wrap">
                        //     <h6 className='font-weight-600'>primary Specialization</h6>
                        //     <div className="tags">
                        //       {this?.props?.PrimaryFieldWork}{' '}{this.props.PrimaryFieldWorkExperience ? '(Exp. '+this.props.PrimaryFieldWorkExperience + ' Yrs)':null}
                        //     </div>
                        //     <h5 className='font-14 text-sub font-weight-600'></h5>
                        //     <h6 className='font-weight-600'>Seconday Specialization</h6>
                        //     {Specilizations.length > 0 ? (
                        //       Specilizations.map((s, k) => {
                        //         return (
                        //           <div key={k} className="tags">
                        //             {s.name}
                        //           </div>
                        //         );
                        //       })
                        //     ) : (
                        //       <></>
                        //     )}
                        //   </div>
                        // </div> 
                        

                    <div className="row m-0 p-3 right_sidebar bor-bottom my-10 ">
                    <div class="col-sm-12 p-0 mb-2 d-flex justify-content-between">
                      <h2 class="text-capitalize text-light-color font-14 font-weight-600">Specializations</h2>
                          {publicView === true ? (
                             <></>
                           ) : (
                             <a href="/"

                               onClick={(e) =>{e.preventDefault();
                                 this.props.OpenPopup('Specialization');
                               }}
                               className="font-12 font-weight-600 text-primary cursor-pointer"
                               data-keyboard="true"
                             // data-toggle="modal"
                             // data-target="#EditSpecializationsModal"
                             >
                                <i className="fas fa-pencil-alt"></i> Edit
                             </a>
                           )}
                    </div>
                    <div class="col-sm-12 p-0 mb-2">
                     <h2 class="text-capitalize text-light-color font-12 font-weight-600">Primary</h2>
                     {!publicView ?<p className="font-12 text-sub font-weight-600 mb-2">{this.props.PrimaryFieldWork} ({!this.props.PrimaryFieldWorkExperience?'0':this.props.PrimaryFieldWorkExperience} Yrs Exp)</p>
                    //  :<p className="font-12 text-sub font-weight-600 mb-2">{this.props.PrimaryFieldWork} ({(this.props.PrimaryFieldWorkExperience + "Yrs Exp")}</p>
                     :<p className="font-12 text-sub font-weight-600 mb-2">{`${this.props.PrimaryFieldWork} ${this.props.PrimaryFieldWorkExperience ?  `(${this.props.PrimaryFieldWorkExperience} Yrs Exp)` :""}`}</p>
                      // }
                      }
                     <h2 class="text-capitalize text-light-color font-12 mt-3 font-weight-600">Secondary</h2>
                     <p className="font-12 text-sub font-weight-600">
                     {Specilizations && Specilizations.length > 0 ? (
                              Specilizations.map((s) => s?.name).join(', ')
                            ) : (
                              <></>
                            )}
                     </p>
                     {/* <p className="font-12 text-sub font-weight-600">UI Design , Branding, Poster Design, Typography</p> */}
                    </div>
                  </div>
                        
                        :
                        <MyListLoader />
                      }
                      {/* {(Tools && Tools.length > 0) ? */}
                      {(!isFetching) ?
                        <div className="row m-0 p-4 bor-bottom ipadPro-p-15">
                          <div className="col-sm-12 dflex p-0">
                            <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                              Tools
                          </h2>
                            {publicView === true ? (
                              <></>
                            ) : (
                              <a href="/"

                                className="font-12 font-weight-600 text-primary cursor-pointer"
                                onClick={(e) =>{ e.preventDefault();this.props.OpenPopup('Tools');}}
                              // data-toggle="modal"
                              // data-target="#EditToolsModal"
                              >
                                <i className="fas fa-pencil-alt"></i> Edit
                              </a>
                            )}
                          </div>
                          <div className="col-sm-12 px-0 pt-3 d-flex align-items-center flex-wrap">
                            {Tools && Tools.length > 0 ? (
                              Tools.map((s, k) => {
                                return (
                                  <div key={k} className="tags">
                                    {s.name}
                                  </div>
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </div>
                        </div> :
                        <MyListLoader />
                      }

                        {/* {(!isFetching) ? */}
                        {(!isFetching) ? (updatedIndustry.length) || !publicView  ?
                        <div className="row m-0 p-4 bor-bottom ipadPro-p-15">
                          <div className="col-sm-12 dflex p-0">
                            <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                              Industries
                          </h2>
                            {publicView === true ? (
                              <></>
                            ) : (
                              <a href="/"

                                className="font-12 font-weight-600 text-primary cursor-pointer"
                                onClick={(e) =>{ e.preventDefault();this.props.OpenPopup('Industries');}}
                              // data-toggle="modal"
                              // data-target="#EditToolsModal"
                              >
                                <i className="fas fa-pencil-alt"></i> Edit
                              </a>
                            )}
                          </div>
                          <div className="col-sm-12 px-0 pt-3 d-flex align-items-center flex-wrap">
                            {updatedIndustry && updatedIndustry.length > 0 ? (
                              updatedIndustry.map((s, k) => {
                                return (
                                  <div key={k} className="tags">
                                    {s.name}
                                  </div>
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>:null :
                        <MyListLoader />
                      }

                      {!isFetching ?
                        (hasClients) || !publicView ?
                          <div className="row m-0 p-4 bor-bottom ipadPro-p-15">
                            <div className="col-sm-12 dflex p-0">
                              <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                                Clients
                            </h2>
                              {publicView === true ?
                                <></>
                                : <a href="/"

                                  onClick={(e) =>{ e.preventDefault();this.props.OpenPopup('Clients');}}
                                  className="font-12 font-weight-600 text-primary cursor-pointer"
                                // data-toggle="modal"
                                // data-target="#EditEducationModal"
                                >
                                  <i className="fas fa-pencil-alt"></i> Edit
                            </a>}
                            </div>
                            <div className="col-sm-12 px-0 pt-3">
                              <div className="row pt-2">
                                {creatorClients && creatorClients.length > 0 && creatorClients.map((client, index) => {
                                  if (!client.client_name || !client.client_image) {
                                    return <></>;
                                  } else {
                                    return (
                                      // <div key={index} className="d-flex align-items-center justify-content-center">
                                      //   <p className="mb-2 ex-perience text-center">
                                      //     <div className="basic_profile">
                                      //       <img
                                      //         src={
                                      //           client.client_image
                                      //             ? CLIENT_IMAGE_BASE_URL +
                                      //               client.client_image
                                      //             : 'https://i.postimg.cc/tgxWpq5p/experience-2.png'
                                      //         }
                                      //         className="border-radius-100"
                                      //         alt="profile"
                                      //         title=""
                                      //         width="50"
                                      //       />
                                      //     </div> 
                                      //     <span className="overflow-text text-dark-black font-14 font-weight-600 text-capitalize d-block">
                                      //       {client.client_name}
                                      //     </span>
                                      //   </p>
                                      // </div>
                                      <div key={index} className="col-sm-12 pl-3">
                                        <div
                                          className="d-flex align-items-center mb-3"
                                        >
                                          <div className="client-content">
                                            <div className="mb-2 ex-perience">
                                              <div className="basic_profile">
                                                <img
                                                  src={
                                                    client.client_image
                                                      ? CLIENT_IMAGE_BASE_URL +
                                                      client.client_image
                                                      : 'https://i.postimg.cc/tgxWpq5p/experience-2.png'
                                                  }
                                                  alt="profile"
                                                  title=""
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="pl-3">
                                            <h2 className="mb-1 font-14 font-weight-600">
                                              {client.client_name}
                                            </h2>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                })}
                              </div>
                            </div>
                          </div> : null
                        : <MyListLoader />}
                      {/* {(Experience && Experience.length > 0) ? */}
                      {(!isFetching) ?
                        Experience.length > 0 || !publicView ?
                          <div className="row m-0 p-4 bor-bottom ipadPro-p-15">
                            <div className="col-sm-12 dflex p-0">
                              <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                                Experience{' '}
                                <span className="text-third">
                                  {Experience.length > 0 ? `${this.props.ExperienceYear} Years` : null}
                                </span>
                              </h2>
                              {publicView === true ? (
                                <></>
                              ) : (
                                <a href="/"
                                  onClick={(e) =>{e.preventDefault();
                                    this.props.OpenPopup('WorkExperience');
                                  }}
                                  className="font-12 font-weight-600 text-primary cursor-pointer"
                                // data-toggle="modal"
                                // data-target="#EditWorkExperienceModal"
                                >
                                  <i className="fas fa-pencil-alt"></i> Edit
                                </a>
                              )}
                            </div>
                            <div className="col-sm-12 px-0 pt-3">
                              {Experience.length > 0 ? (
                                Experience.sort((a, b) => new Date(b.end_data_sort).getTime() - new Date(a.end_data_sort).getTime()).map((s, k) => {
                                  // {
                                  //   /* console.log(
                                  //   'company_image in creator ',
                                  //   s.company_image
                                  // ); */
                                  // }
                                  return (
                                    <div
                                      key={k}
                                      className="d-flex mb-3"
                                    >
                                      <div className="">
                                        <p className="mb-2 profile_experience">
                                          <img
                                            src={
                                              s.company_image
                                                ? `https://indiefolio-images.s3.ap-south-1.amazonaws.com/company/profile/${s.company_image}`
                                                : companyImg
                                            }
                                            alt="profile"
                                            title=""
                                          />
                                        </p>
                                      </div>
                                      <div className="pl-3">
                                        <h2 className="mb-1 font-14 font-weight-600">
                                          {s.designation}
                                        </h2>
                                        <span className="profile-subTitle font-12 text-capitalize d-block">
                                          {s.company_name}
                                          <span className=" pl-3">
                                            {s.Position}
                                          </span>
                                        </span>
                                        <span className="profile-subTitle font-12 text-capitalize">
                                          {s.is_current === 1 || s.is_current ? (
                                            <>
                                              {s.start_month} {s.start_year} -
                                              present
                                            </>
                                          ) : (
                                            <>
                                              {s.start_month} {s.start_year} -{' '}
                                              {s.end_month !== '' && s.end_year !== '' ?
                                                <>
                                                  {s.end_month} {s.end_year}
                                                </>
                                                :
                                                'present'
                                              }
                                            </>
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <></>
                              )}
                            </div>
                          </div> : null :
                        <MyListLoader />}
                      {/* {Education &&  Education.length > 0 ?  */}
                      {!isFetching ?
                        (Education && Education.length > 0) || !publicView ?
                          <div className="row m-0 p-4 bor-bottom ipadPro-p-15">
                            <div className="col-sm-12 dflex p-0 mb-3">
                              <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                                Education
                            </h2>
                              {publicView === true ? (
                                <></>
                              ) : (
                                <a href="/"

                                  onClick={(e) =>{ e.preventDefault(); this.props.OpenPopup('Education');}}
                                  className="font-12 font-weight-600 text-primary cursor-pointer"
                                // data-toggle="modal"
                                // data-target="#EditEducationModal"
                                >
                                  <i className="fas fa-pencil-alt"></i> Edit
                                </a>
                              )}
                            </div>
                            {Education && Education.length > 0 ? (
                              Education.sort((a, b) => new Date(b.end_data_sort).getTime() - new Date(a.end_data_sort).getTime()).map((s, k) => {
                                // {
                                //   /* console.log('image ', s); */
                                // }
                                return (
                                  <div key={k} className="col-sm-12 px-0">
                                    <div className="d-flex mb-2 pt-2">
                                      <div className="">
                                        <p className="mb-2 ex-perience">
                                          <img
                                            src={
                                              s.Institute_image
                                                ? `https://indiefolio-images.s3.ap-south-1.amazonaws.com/institute/logo/${s.Institute_image}`
                                                : educationImg
                                            }
                                            alt="profile"
                                            title=""
                                            width="50"
                                          />
                                        </p>
                                      </div>
                                      <div className="pl-3">
                                        <h2 className="mb-1 font-14 font-weight-600">
                                          {s.Institute_name}
                                        </h2>
                                        <span className="profile-subTitle font-12 text-capitalize d-block">
                                          {s.course}
                                        </span>
                                        <span className="profile-subTitle font-12 text-capitalize">
                                          {s.start_month} {s.start_year} -{' '}
                                          {s.end_month} {s.end_year}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <></>
                            )}
                          </div> : null :
                        <MyListLoader />}

                      {!isFetching ?
                        (Award && Award.length > 0) || !publicView ?
                          <div className="row m-0 p-4 bor-bottom ipadPro-p-15">
                            <div className="col-sm-12 dflex p-0">
                              <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                                Awards & Mentions
                              </h2>
                              {publicView === true ? (
                                <></>
                              ) : (
                                <a href="/"
                                  //
                                  className="font-12 font-weight-600 text-primary cursor-pointer"
                                  onClick={(e) =>{ e.preventDefault(); this.props.OpenPopup('Awards');}}
                                >
                                  <i className="fas fa-pencil-alt"></i> Edit
                                </a>
                              )}
                            </div>
                            <div className="col-sm-12 pl-2 pt-3">
                              {Award && Award.length > 0 ? (
                                Award.map((s, k) => {
                                  return (
                                    <div
                                      key={k}
                                      className="d-flex align-items-center mb-2 pt-2"
                                    >
                                      <div className="">
                                        <p className="mb-2">
                                          <img
                                            src={require('../../../Assets/images/awards.png')}
                                            className="d-block m-auto"
                                            width="25"
                                            alt="IndieFolio"
                                          />
                                        </p>
                                      </div>
                                      <div className="pl-3">
                                        <h2 className="mb-1 font-14 font-weight-600" style={{ wordBreak: "break-word"}}>
                                          {s.type === 'awards' ? `${s.award_name}` : `${s.title}`}
                                        </h2>
                                        <span className="profile-subTitle font-12 text-capitalize d-block">
                                          {s.type === 'awards' ? `${s.awarder}-Awards` : `${s.publication}-Mentions`}
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <></>
                              )}
                            </div>
                          </div> : null :
                        <MyListLoader />}

                      {!isFetching ?
                        (Languages && Languages.length > 0) || !publicView ?
                          <div className="row m-0 p-4 ipadPro-p-15 mob-mb-80 ipad-mb-70">
                            <div className="col-sm-12 dflex p-0">
                              <h2 className="text-capitalize text-light-color font-15 font-weight-600 text-underline mb-0 active">
                                Languages
                            </h2>
                              {publicView === true ? (
                                <></>
                              ) : (
                                <a href="/"

                                  className="font-12 font-weight-600 text-primary cursor-pointer"
                                  onClick={(e) =>{ e.preventDefault(); this.props.OpenPopup('Languages');}}
                                // data-toggle="modal"
                                // data-target="#EditLanguagesModal"
                                >
                                  <i className="fas fa-pencil-alt"></i> Edit
                                </a>
                              )}
                            </div>
                            <div className="col-sm-12 px-0 pt-3 d-flex align-items-center flex-wrap">
                              {Languages && Languages.length > 0 ? (
                                Languages.map((obj, k) => {
                                  return (
                                    <div key={k} className="tags">
                                      {obj.name ? obj.name : obj}
                                    </div>
                                  );
                                })
                              ) : (
                                <></>
                              )}
                            </div>
                          </div> :
                          null :
                        <MyListLoader />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Popup {...this.props} {...this.state}/>
        {userName ? <FixFooter /> : null}
      </React.Fragment>
    );
  }
}

const mapState = (store) => {
  // console.log(store)
  let creatorProfile = store.creatorProfile;
  let projectSubmitted = store.project;
  let dashboard = store.dashboard;
  let globalReducer = store.globalReducer;
  return {
    publicCurrentRoleSet: creatorProfile.BasicDetails.UserDataPublic?.current_set_role,
    publicStatus: creatorProfile.BasicDetails.UserDataPublic?.status,
    isFetching: creatorProfile.isFetching,
    publicView: creatorProfile.public,
    FirstName: creatorProfile.FirstName,
    LastName: creatorProfile.LastName,
    isAvailable: creatorProfile.isAvailable,
    Avatar: creatorProfile.Avatar,
    Location: creatorProfile.Location,
    Country: creatorProfile.Country,
    PrimaryFieldWork: creatorProfile.PrimaryFieldWork,

    PrimaryFieldWorkExperience: creatorProfile.PrimaryFieldWorkExperience,

    About: creatorProfile.About,
    Rating: creatorProfile.UserReview.Rating,
    Reviews: creatorProfile.UserReview.Reviews,
    RepeatHire: creatorProfile.RepeatHire,
    ProjectCompleted: creatorProfile.ProjectCompleted,
    AvgResponseTime: creatorProfile.AvgResponseTime,
    ExperienceYear: creatorProfile.ExperienceYear,
    AllReviews: creatorProfile.Reviews,
    SocialProfiles: creatorProfile.SocialProfile,
    Collateral: creatorProfile.CollateralListing,
    Specilizations: creatorProfile.Specilizations,
    Tools: creatorProfile.Tools,
    Experience: creatorProfile.Experience,
    Education: creatorProfile.Education,
    Languages: creatorProfile.Languages,
    CreatorId: creatorProfile.CreatorId,
    Award: creatorProfile.Awards,
    creatorClients: creatorProfile.creatorClients,
    //Projects: creatorProfile.Projects,
    CurrentWorkStatus: creatorProfile.CurrentWorkStatus,
    projectSubmitted: projectSubmitted.project_submitted,
    Projects: dashboard.Projects,
    AllProjects: dashboard.AllProjects,
    defaultCollateral: dashboard.defaultCollateral,
    userName: globalReducer.Me.Username,
    ApprovedStatus: globalReducer.Me.ApprovedStatus,
    AllIndustry:store.userWork.AllIndustry,
    UserIndustries:creatorProfile.UserIndustries,

  };
};
const mapDispatch = (dispatch) => ({
  onFieldChange: (e) =>
    dispatch({
      type: 'ON_FIELDCHANGE_SAGA',
      payload: { name: e.name, value: e.value },
    }),
  OpenPopup: (text) =>
    dispatch({ type: 'OPEN_POPUP_SAGA', payload: { Component: text } }),
  closePopup: () => dispatch({ type: 'CLOSE_POPUP_SAGA', payload: {} }),
  LoadProjectData: (id) =>
    dispatch({ type: 'LOAD_PROJECT_DATA', payload: { id } }),
  editUserProject: (id, history) =>
    dispatch({ type: 'EDIT_PROJECT', payload: { id, history } }),
  LoadCollateralBasedProjects: (e) =>
    dispatch({ type: 'LOAD_COLLATERAL_BASED_PROJECTS', payload: e }),
  ResetCollateralBasedProjects: () =>
    dispatch({ type: 'RESET_COLLATERAL_PROJECTS_DATA', payload: null }),
  DeleteCreatorProject: (id, isFromAllProjects) =>
    dispatch({ type: 'DELETE_CREATOR_PROJECT', payload: { id, isFromAllProjects } }),
  hireAgain: (creatorId) => dispatch({ type: 'UPDATE_HIRE_AGAIN_STATUS', values: { creatorId: creatorId, isHireAgain: true } }),
  loadAllProjects: () => dispatch({ type: 'LOAD_ALL_PROJECTS_SAGA', values: null }),
});
export default withRouter(connect(mapState, mapDispatch)(ViewCreatorProfile));

